import React from "react";
import { get, useFormContext } from "react-hook-form";
import { Controller } from "react-hook-form";
import FieldLabel from "./FieldLabel";
import { NumericFormat } from "react-number-format";
import { TextField } from "@mui/material";

const FormControlNumericInput = ({ name, label, required, control: controlProps, ...props } = {}) => {
  const { control: controlContext } = useFormContext();
  const control = controlProps || controlContext;
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, formState: { errors } }) => {
        const error = get(errors, name);
        return (
          <NumericFormat
            {...props}
            fullWidth
            label={
              !!label ? (
                <FieldLabel
                  label={label}
                  required={required}
                />
              ) : null
            }
            value={field.value}
            onValueChange={(values) => field.onChange(values.floatValue ?? "")}
            error={!!error}
            helperText={error?.message}
            customInput={TextField}
            slotProps={{ formHelperText: { sx: { mx: "0px" } } }}
          />
        );
      }}
    />
  );
};

export default FormControlNumericInput;
